import { Controller, del } from "@hotwired/stimulus"

// Connects to data-controller="schedule-entries--entry"
export default class extends Controller {
  connect() {
  }

  edit(event) {
    if (event.target.closest(".schedule-entry__remove-button")) {
      return
    }
    
    const url = this.element.dataset.editUrl
    Turbo.visit(url.toString(), { frame: "modal" })
  }
}
